import { Play, Loader2 } from "lucide-react";

/**
 * AnalyzeButton — runs the Market Analysis when enabled.
 *
 * Props:
 *   loading  — show spinner + disable while the LLM is working.
 *   disabled — extra guard (e.g. no candles loaded yet).
 */
export default function AnalyzeButton({ disabled = false, loading = false, onClick }) {
  const isBusy = loading || disabled;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isBusy}
      data-testid="market-analyze-btn"
      title={loading ? "Analyzing…" : disabled ? "Waiting for chart data" : "Run AI Market Analysis"}
      className="inline-flex items-center gap-2 bg-white text-black font-bold text-xs uppercase tracking-[0.2em] px-4 py-2 hover:bg-neutral-200 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
    >
      {loading
        ? <Loader2 className="w-3.5 h-3.5 animate-spin" />
        : <Play className="w-3.5 h-3.5" />}
      {loading ? "analyzing…" : "analyze"}
    </button>
  );
}
